import React, { FC } from 'react';
import styles from './notification_link_content.module.scss';

export const NotificationLinkContent: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
